<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeParametrageEdition.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit" @click="addEditParametrage(null)"
               :class="{'button-access-no-permission' :
               !checkPermissions(permsParametrageEdition.maj) }">
              {{ $t('listeParametrageEdition.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('listeParametrageEdition.actions.search')"
                     type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-server-table :columns="columns" :options="options" @loaded="finLoading"
                    @loading="debutLoading"
                    ref="tableParametrageEdition">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableParametrageEdition.setLimit($event)"/>
      </template>
      <div slot="afficherLogo" slot-scope="props">
        {{ props.row.afficherLogo ? $t('general.oui') :  $t('general.non') }}
      </div>
      <div slot="typeEdition" slot-scope="props">
        {{ $t(getLibelleTypeEdition(props.row.typeEdition))  }}
      </div>
      <div slot="afficherPiedPage" slot-scope="props">
        {{ props.row.afficherPiedPage ? $t('general.oui') :  $t('general.non') }}
      </div>
      <div slot="edit" slot-scope="props">
        <div @click="checkPermissions(permsParametrageEdition.supprimer) ?
        addEditParametrage(props.row) : showPopUp()" class="is-cursor-pointer">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsParametrageEdition.maj) }"></b-icon>
        </div>
      </div>
      <div slot="archiver">
        <div @click="checkPermissions(permsParametrageEdition.supprimer) ? inProgress() :
            showPopUp()" class="is-cursor-pointer">
          <b-icon type="is-default" icon="archive"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsParametrageEdition.supprimer) }">
          </b-icon>
        </div>
      </div>
      <div slot="delete">
        <div @click="checkPermissions(permsParametrageEdition.supprimer) ? inProgress() :
            showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(permsParametrageEdition.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <b-modal v-model="popUpAddParametrageEdition" has-modal-card class="modal">
      <add-edit-parametrage-edition :parametrageEdition="selectedParametrage"
                                    @reloadParametrageEdition="recherche()">
      </add-edit-parametrage-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import inProgress from '@/services/general/inProgress';
import { PARAMETRAGE_EDITION } from '@/configuration/general/permissionsParametrageConf';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import genererParametrageEdition from '@/services/parametrage/generation/genererParametrageEdtion';
import addEditParametrageEdition from '@/components/parametrage/parametrageEdition/p_addEditParametrageEdition';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { EDITION_LISTE_TYPES } from '@/configuration/edition/editionConf';

const Permissions = createNamespacedHelpers('permissions');
const ParametrageEditon = createNamespacedHelpers('parametrageEdition');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permsParametrageEdition: PARAMETRAGE_EDITION,
      popUpAddParametrageEdition: false,
      selectedParametrage: {},
      unsubscribeValue: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    addEditParametrageEdition,
    TableItemsInView,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$t('listeParametrageEdition.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeParametrageEdition.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeParametrageEdition.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...ParametrageEditon.mapGetters({
      items: 'items',
      critereRecherche: 'critereRecherche',
      totalCount: 'totalCount',
    }),
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          typeEdition: this.$t('listeParametrageEdition.tab.typeEdition'),
          afficherLogo: this.$t('listeParametrageEdition.tab.afficherLogo'),
          afficherPiedPage: this.$t('listeParametrageEdition.tab.afficherPiedPage'),
          margeHaut: this.$t('listeParametrageEdition.tab.margeHaut'),
          margeBas: this.$t('listeParametrageEdition.tab.margeBas'),
          margeDroite: this.$t('listeParametrageEdition.tab.margeDroite'),
          margeGauche: this.$t('listeParametrageEdition.tab.margeGauche'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = {
            auto: this.critereRecherche.auto,
            societeId: this.societeActiveId,
          };
          return this.actionsLoadParametrageEdition(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['libelle'],
      };
    },
    columns() {
      return ['typeEdition', 'afficherLogo', 'afficherPiedPage', 'margeHaut', 'margeBas', 'margeGauche', 'margeDroite', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...ParametrageEditon.mapActions({
      actionsLoadParametrageEdition: 'loadParametrageEdition',
    }),
    goFirstPage() {
      this.$refs.tableParametrageEdition.setPage(1);
    },
    recherche() {
      this.$refs.tableParametrageEdition.refresh();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    addEditParametrage(parametrage) {
      if (!parametrage) this.selectedParametrage = genererParametrageEdition();
      else this.selectedParametrage = cloneDeep(parametrage);
      this.popUpAddParametrageEdition = true;
    },
    getLibelleTypeEdition(key) {
      const typeEdition = EDITION_LISTE_TYPES.find((type) => { return key === type.key; });
      if (typeEdition) return typeEdition.libelle;
      return '';
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageParametrage.parametrageEdition.liste'));
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
